import React from "react";

interface RulesTabComingSoonProps {
  label: string;
}

export const RulesTabComingSoon = ({ label }: RulesTabComingSoonProps) => (
  <div className="flex flex-column align-items-center justify-content-center py-6 gap-3">
    <i className="pi pi-clock text-4xl text-500" />
    <p className="m-0 text-lg text-600">{label}</p>
    <p className="m-0 text-sm text-500">Próximamente</p>
  </div>
);
